// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__34334","sideContainer":"About_sideContainer__1SRnz","aboutContainer":"About_aboutContainer__3dzCO","creditsItems":"About_creditsItems__2eQ2n"};